// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"671d480a","239":"db6ceebd","453":"8806ced5","455":"a19419af"}[chunkId] + ".chunk.js";
};